var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-time-select",
    _vm._b(
      {
        class: { isView: _vm.mode !== "edit" },
        attrs: {
          value: _vm.inputVal,
          placeholder: _vm.placeholderTxt,
          "value-format": _vm.valueformat,
          clearable: "",
          disabled: _vm.isDisabled,
        },
        on: { input: _vm.onChange, change: _vm.onChange },
      },
      "el-time-select",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }